<template>
  <div id="wrapper-dashboard-index">
    <b-container fluid class="p-0" v-if="!lumbredocs_v3">
      <b-row no-gutters>
        <b-col class="col-left col-auto" :class="{'col-left-expanded': expanded}">
          <LmColumnMenu :menuItems="mainMenuItems"></LmColumnMenu>
        </b-col>
        <b-col class="col-right">
          <LmHeader />
          <router-view />
          <div class="no-search-found">
            <img src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
            <h1>{{$t('404_message_h1')}}</h1>
            <h2>{{$t('404_message_h2')}}</h2>
          </div>
          <LmFooter />
        </b-col>
      </b-row>
    </b-container>

    <section class="lumbre-container" v-else>
      <LmHeader @toggleMenu="expanded = !expanded" />

      <div class="lumbre-app">

        <div class="app-menu" :class="{ 'expanded': expanded }">
          <LmMenu :expanded="expanded" @expand="expanded = true" />
        </div>

        <section class="app-view">
          <div class="no-search-found">
            <img src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
            <h1>{{$t('404_message_h1')}}</h1>
            <h2>{{$t('404_message_h2')}}</h2>
          </div>
          <LmFooter />
        </section>

      </div>

    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmColumnMenu from '@/components/LmColumnMenu.vue'
import LmMenu from '@/components/LmMenu'
import LmHeader from '@/components/LmHeader.vue'
import LmFooter from '@/components/LmFooter.vue'

export default {
  inject: ['lumbredocs_v3'],
  data () {
    return {
      expanded: true
    }
  },
  computed: {
    ...mapState('settings', ['mainMenuItems', 'loading'])
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings'])
  },
  created () {
    this.getMainMenuSettings()
  },
  components: {
    LmColumnMenu,
    LmHeader,
    LmFooter,
    LmMenu
  }
}
</script>

<style lang="sass" scoped>
#wrapper-dashboard-index
  height: 100vh

  .lumbre-container
    height: 100vh

    .lumbre-app
      display: flex
      overflow: hidden
      min-height: calc(100vh - 70px)

      .app-menu
        display: none
        transition: ease-in-out all .2s
        @media (min-width: $md)
          display: flex
          flex: 0 0 8%
          &.expanded
            flex: 0 0 20%
        @media (min-width: $xxl)
          display: flex
          flex: 0 0 5%
          &.expanded
            flex: 0 0 15%
        @media (max-width: $md)
          &.expanded
            position: fixed
            z-index: 999
            display: block
            width: 85%

      .app-view
        height: calc(100vh - 70px)
        flex: 1 1 100%
        display: flex
        justify-content: space-between
        flex-direction: column
        overflow-y: auto
        overflow-x: hidden

        &::-webkit-scrollbar
          width: 8px
        &::-webkit-scrollbar-track
          background: #f1f1f1
        &::-webkit-scrollbar-thumb
          border-radius: 20px
          background: #888
        &::-webkit-scrollbar-thumb:hover
          background: #555

  .col-right
    display: flex
    flex-direction: column
    min-height: 100vh
  .col-left
    transition: flex-basis 0.2s ease
    @media(min-width: $xl)
      flex: 0 1 80px
    &.col-left-expanded
      @media(min-width: $xl)
        flex: 0 1 235px
  .no-search-found
    padding: 5%
    flex-grow: 1
    img
      margin: 0 auto 30px auto
      display: block
      @media(max-width: $md)
        max-width: 50%
    h1,
    h2
      color: $primaryFontThemeColor
      max-width: 700px
      margin: 0 auto
      text-align: center
      @media(max-width: $md)
        min-width: 100px
    h1
      font-size: 24px
      margin-bottom: 10px
      @media(max-width: $md)
        font-size: 18px
    h2
      font-size: 18px
      @media(max-width: $md)
        font-size: 14px
</style>
